import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../components/common/SectionTitle/SectionTitle";
import About1 from '../../assets/images/about-1.jpg';
import About2 from "../../assets/images/about-2.jpg";
import About3 from "../../assets/images/about-3.png";
import btatcLogo from "../../assets/images/logo-btatc.png";
import RiyadhShowroom from "../../assets/images/riyadh-showroom.jpg"
import './AboutUsPage.css'
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";

export default function AboutUsPage() {



    return (
        <div className="about-us-page">
            <div className="section-spacing text-center">
                <SectionTitle
                    subtitle="A Story of"
                    title="Power, Precision & Purpose"
                />
                <p className="brand-section-desc">Where Global Engineering Meets Saudi Ambition</p>
            </div>

            <Container fluid>

                <div className="sec-content text-center">
                    <h3>Powering the Future of Commercial Mobility in Saudi Arabia</h3>
                    <p className="para-width">LANDKING Trucks represents a new generation of commercial vehicles engineered for performance, efficiency, and long-term reliability. Backed by world-class manufacturing and brought to the Kingdom by a trusted local partner, LANDKING is redefining what businesses should expect from their trucks.</p>
                </div>

                <div className="section-spacing">
                    <Row className="align-items-center">
                        <Col md={12} lg={6}>
                            <div className="about1-img">
                                <img src={About1} />
                            </div>

                        </Col>

                        <Col md={12} lg={6}>

                            <SectionTitle
                                subtitle="About Wechai Group"
                                title="The Global Force Behind LANDKING"
                            />

                            <div className="sec-content">
                                <p>Founded in 1946, Weichai Group is one of the world’s most powerful and respected manufacturers of engines, powertrains, and commercial vehicles. With operations across 150+ countries and regions, over 100,000 employees worldwide, and decades of industrial leadership, Weichai stands at the forefront of global commercial vehicle innovation.</p>
                                <p>Weichai’s strength lies in complete vertical integration engines, transmissions, axles, electronics, and intelligent systems are developed within the group, ensuring unmatched control over quality, performance, and reliability. This engineering philosophy powers industries ranging from logistics and construction to agriculture, marine mobility, and intelligent transportation systems.</p>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="about-sec-2">
                    <Row className="align-items-center">
                        <Col md={12} lg={7}>
                            <SectionTitle
                                subtitle="Weichai New Energy Commercial Vehicle"
                                title="Established in 2005"
                            />

                            <div className="sec-content">
                                <p>Weichai New Energy Commercial Vehicle is a core strategic division of the Weichai Group, dedicated to light- and medium-duty commercial vehicles. Operating with advanced R&D located in Tokyo, Japan, intelligent manufacturing, and large-scale production capabilities, the division delivers hundreds of thousands of vehicles annually to global markets.</p>
                            </div>
                        </Col>

                        <Col md={12} lg={5}>
                            <div className="about1-img">
                                <img src={About2} />
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="section-spacing">
                    <div className="about-tagline">
                        <p>"LANDKING is one of its flagship brands, designed to meet modern logistics demands with advanced technology, durable construction, and optimized operating efficiency."</p>
                    </div>
                </div>

                <div className="about-sec-3">
                    <Row className="align-items-center">
                        <Col md={12} lg={4}>
                            <div className="about3-img">
                                <img src={About3} />
                            </div>
                        </Col>

                        <Col md={12} lg={8}>
                            <SectionTitle
                                subtitle="LANDKING Trucks"
                                title="Engineered to Challenge"
                            />

                            <div className="sec-content">
                                <p>LANDKING is not built to follow industry standards, it is built to challenge them.</p>

                                <p>From intelligent powertrain systems to driver-focused cabins and rugged chassis engineering, LANDKING trucks are purpose-built for demanding commercial environments. Every vehicle reflects Weichai’s deep expertise in power, endurance, and system-level engineering delivering performance that lasts, not just impresses on paper.</p>

                                <p>LANDKING trucks are engineered for:</p>
                            </div>

                            <Row>
                                <Col lg={6}>
                                    <div className="about-highlight-card">
                                        <div className="highlight-count-holder">
                                            <span>1</span>
                                        </div>
                                        <p>High uptime and long service life</p>
                                    </div>
                                </Col>

                                <Col lg={6}>
                                    <div className="about-highlight-card">
                                        <div className="highlight-count-holder">
                                            <span>2</span>
                                        </div>
                                        <p>Lower total cost of ownership</p>
                                    </div>
                                </Col>

                                <Col lg={6}>
                                    <div className="about-highlight-card">
                                        <div className="highlight-count-holder">
                                            <span>3</span>
                                        </div>
                                        <p>Advanced driver comfort and control</p>
                                    </div>
                                </Col>

                                <Col lg={6}>
                                    <div className="about-highlight-card">
                                        <div className="highlight-count-holder">
                                            <span>4</span>
                                        </div>
                                        <p>Proven reliability under extreme conditions</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>

                <div className="section-spacing-top">
                    <div className="divider-with-image">
                        <span className="divider-line"></span>

                        <img
                            src={btatcLogo}
                            alt="Section Divider"
                            className="divider-image"
                        />

                        <span className="divider-line"></span>
                    </div>
                    <div className="about-tagline-2">
                        <h4>LANDKING Dealer in Saudi Arabia</h4>
                    </div>
                </div>

                <Row className="align-items-center">
                    <Col lg={6}>
                        <div className="sec-content mb-4">
                            <p><b>BTATC (Bawabat Altawrid Alalamiya for Trading Company) is the authorized dealer of LANDKING Trucks in the Kingdom of Saudi Arabia.</b></p>
                            <p>BTATC brings deep local market knowledge, strong operational capability, and a long-term commitment to customer success. More than a distributor, BTATC is a full-scope partner responsible for sales, aftersales support, spare parts availability, and localized service infrastructure across the Kingdom.</p>
                            <p>By combining Weichai’s global engineering strength with BTATC’s on-ground execution, LANDKING customers in Saudi Arabia gain access to a commercial vehicle ecosystem built for reliability, transparency, and long-term growth.</p>
                        </div>

                        <div className="vmv-content">
                            <h5>Our Vision</h5>
                            <p>To become the most trusted commercial truck brand in Saudi Arabia by delivering vehicles that outperform expectations in durability, efficiency, and value.</p>
                        </div>

                        <div className="vmv-content">
                            <h5>Our Mission</h5>
                            <p>To empower businesses across the Kingdom with robust, technologically advanced trucks supported by reliable service, competitive ownership costs, and uncompromising quality standards.</p>
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="showroom-image">
                            <img src={RiyadhShowroom} />
                        </div>
                    </Col>
                </Row>

                <div className="section-spacing">
                    <div className="vmv-title">
                        <h4>Our Values</h4>
                    </div>

                    <Row>
                        <Col md={6} lg={3}>
                            <div className="value-content">
                                <h6>Engineering Integrity</h6>
                                <p className="text-center">Every LANDKING vehicle is built on proven technology, not shortcuts.</p>
                            </div>
                        </Col>

                        <Col md={6} lg={3}>
                            <div className="value-content">
                                <h6>Customer-Centric Reliability</h6>
                                <p className="text-center">Uptime matters. Our products and support systems are designed to keep businesses moving.</p>
                            </div>
                        </Col>

                        <Col md={6} lg={3}>
                            <div className="value-content">
                                <h6>Market-Challenging Innovation</h6>
                                <p className="text-center">We continuously raise benchmarks instead of accepting industry norms.</p>
                            </div>
                        </Col>

                        <Col md={6} lg={3}>
                            <div className="value-content">
                                <h6>Long-Term Partnership</h6>
                                <p className="text-center">We don’t sell trucks, we build relationships that last across the vehicle lifecycle.</p>
                            </div>
                        </Col>
                    </Row>
                </div>

            </Container>

            <AftersalesSupportSection/>
        </div>
    );
}